import './App.css';
import React, { useState } from "react";
import hanzi from "./components/hanzi.json";
import Card from './components/Card';
import Footer from './components/Footer';
import Fuse from "fuse.js";
import SearchBar from './components/Searchbar';

function App() {
  const [data, setData] = useState(hanzi);

  const searchData = (pattern) => {
    if (!pattern) {
      setData(hanzi);
      return;
    }

    const fuse = new Fuse(data, {
      keys: 
      [{ name: 'hanzi', weight: 0.6 }, 
        {name: 'level', weight: 0.5},
      { name: 'traditional', weight: 0.3 }, 
      { name: 'heisig', weight: 0.5 }, 
            { name: 'pinyin', weight: 0.3 }, 
                  { name: 'plain_pinyin', weight: 0.3 }, 
      { name: 'keywords', weight: 0.9 }],
      threshold: 0.4,
      distance: 250,
    });

    const result = fuse.search(pattern);
    const matches = [];
    if (!result.length) {
      setData([]);
    } else {
      result.forEach(({item}) => {
        matches.push(item);
      });
      setData(matches);
    }
  };

  return (
    <div>
      <h1 className="Title">Hanzi Search</h1>
      <SearchBar
        placeholder="Search"
        onChange={(e) => searchData(e.target.value)}
       />

      <div className="Container">
        {data.slice(0, 100).map((item) => (
          <Card {...item} key={item.hanzi} />
        ))}
      </div>

    </div>
  );
}

export default App;
